import React from 'react';

/* ── Lark-style coloured SVG icons ── */
const IconMeetingMinute = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
    <rect x="4" y="3" width="16" height="20" rx="3" fill="#3B82F6" opacity="0.15"/>
    <rect x="7" y="6" width="16" height="20" rx="3" fill="#3B82F6"/>
    <rect x="11" y="12" width="8" height="1.5" rx="0.75" fill="#fff"/>
    <rect x="11" y="15.5" width="6" height="1.5" rx="0.75" fill="#fff" opacity="0.7"/>
    <rect x="11" y="19" width="5" height="1.5" rx="0.75" fill="#fff" opacity="0.5"/>
  </svg>
);

const IconSurveyForm = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
    <rect x="5" y="4" width="18" height="20" rx="3" fill="#8B5CF6"/>
    <rect x="9" y="9" width="4" height="4" rx="1" fill="#fff" opacity="0.4"/>
    <rect x="15" y="10" width="5" height="1.5" rx="0.75" fill="#fff"/>
    <rect x="9" y="15" width="4" height="4" rx="1" fill="#fff" opacity="0.4"/>
    <rect x="15" y="16" width="5" height="1.5" rx="0.75" fill="#fff"/>
    <path d="M10 11l1.5 1.5L14 10" stroke="#fff" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconAICoaching = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
    <circle cx="14" cy="14" r="10" fill="#F59E0B" opacity="0.15"/>
    <circle cx="14" cy="14" r="7" fill="#F59E0B"/>
    <path d="M14 10v4.5l3 1.5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11 9l3 2 3-2" stroke="#fff" strokeWidth="1.2" strokeLinecap="round" opacity="0.7"/>
  </svg>
);

const IconTrainingNeeds = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
    <rect x="4" y="6" width="20" height="16" rx="3" fill="#10B981"/>
    <rect x="7" y="9" width="6" height="1.5" rx="0.75" fill="#fff"/>
    <rect x="7" y="12.5" width="10" height="1.5" rx="0.75" fill="#fff" opacity="0.6"/>
    <rect x="7" y="16" width="8" height="1.5" rx="0.75" fill="#fff" opacity="0.4"/>
    <circle cx="21" cy="19" r="5" fill="#059669"/>
    <path d="M19.5 19l1 1 2-2.5" stroke="#fff" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconAudioPlayback = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
    <rect x="4" y="4" width="20" height="20" rx="10" fill="#EC4899" opacity="0.15"/>
    <circle cx="14" cy="14" r="7" fill="#EC4899"/>
    <path d="M12 11v6l5-3z" fill="#fff"/>
  </svg>
);

const IconLocation = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
    <path d="M14 3C9.58 3 6 6.58 6 11c0 6.5 8 14 8 14s8-7.5 8-14c0-4.42-3.58-8-8-8z" fill="#3B82F6"/>
    <circle cx="14" cy="11" r="3" fill="#fff"/>
  </svg>
);

const IconPerformanceScoring = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
    <rect x="4" y="4" width="20" height="20" rx="3" fill="#F97316" opacity="0.15"/>
    <rect x="7" y="14" width="3.5" height="7" rx="1" fill="#F97316"/>
    <rect x="12.25" y="10" width="3.5" height="11" rx="1" fill="#F97316" opacity="0.7"/>
    <rect x="17.5" y="7" width="3.5" height="14" rx="1" fill="#F97316"/>
  </svg>
);

const IconCustomization = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
    <circle cx="14" cy="14" r="10" fill="#6366F1" opacity="0.15"/>
    <circle cx="14" cy="14" r="5" fill="#6366F1"/>
    <circle cx="14" cy="14" r="2" fill="#fff"/>
    <rect x="13" y="2" width="2" height="4" rx="1" fill="#6366F1" opacity="0.5"/>
    <rect x="13" y="22" width="2" height="4" rx="1" fill="#6366F1" opacity="0.5"/>
    <rect x="22" y="13" width="4" height="2" rx="1" fill="#6366F1" opacity="0.5"/>
    <rect x="2" y="13" width="4" height="2" rx="1" fill="#6366F1" opacity="0.5"/>
  </svg>
);

const IconFollowUp = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
    <rect x="3" y="6" width="16" height="12" rx="3" fill="#10B981"/>
    <rect x="9" y="10" width="16" height="12" rx="3" fill="#10B981" opacity="0.6"/>
    <rect x="12" y="14" width="8" height="1.5" rx="0.75" fill="#fff"/>
    <rect x="12" y="17" width="5" height="1.5" rx="0.75" fill="#fff" opacity="0.7"/>
  </svg>
);

const IconTrafficAnalytics = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
    <rect x="4" y="4" width="20" height="20" rx="3" fill="#EF4444" opacity="0.15"/>
    <path d="M8 18l4-4 3 2 5-6" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="20" cy="10" r="2" fill="#EF4444"/>
  </svg>
);

// Shared icon/color/screenshot descriptors
const featureBase = [
  {
    id: 'meeting-minute',
    IconComp: IconMeetingMinute,
    iconBg: '#EFF6FF',
    accentColor: '#3B82F6',
    sectionScreenshots: [
      '/images/salesperson/salesperson-meeting-notes1.png',
      '/images/salesperson/salesperson-meeting-notes4.png',
    ],
  },
  {
    id: 'survey-form',
    IconComp: IconSurveyForm,
    iconBg: '#F5F3FF',
    accentColor: '#8B5CF6',
    sectionScreenshots: [
      '/images/company-admin/company-admin-personalization1.png',
      '/images/company-admin/company-admin-dashboard1.png',
    ],
  },
  {
    id: 'ai-coaching',
    IconComp: IconAICoaching,
    iconBg: '#FFFBEB',
    accentColor: '#F59E0B',
    sectionScreenshots: [
      '/images/manager/company-manager-AI-coaching.png',
      '/images/company-admin/company-admin-customer-experience.png',
      '/images/manager/company-manager-dashboard1.png',
    ],
  },
  {
    id: 'training-needs',
    IconComp: IconTrainingNeeds,
    iconBg: '#ECFDF5',
    accentColor: '#10B981',
    sectionScreenshots: [
      '/images/manager/company-manager-training-needs.png',
    ],
  },
  {
    id: 'audio-playback',
    IconComp: IconAudioPlayback,
    iconBg: '#FDF2F8',
    accentColor: '#EC4899',
    sectionScreenshots: [
      '/images/company-admin/company-admin-communicationlogs.png',
      '/images/admin/admin-sql-logs.png',
    ],
  },
  {
    id: 'location',
    IconComp: IconLocation,
    iconBg: '#EFF6FF',
    accentColor: '#3B82F6',
    sectionScreenshots: [
      '/images/manager/company-manager-dashboard2.png',
      '/images/manager/company-manager-dashboard1.png',
    ],
  },
  {
    id: 'performance-scoring',
    IconComp: IconPerformanceScoring,
    iconBg: '#FFF7ED',
    accentColor: '#F97316',
    sectionScreenshots: [
      '/images/company-admin/company-admin-dashboard1.png',
      '/images/company-admin/company-admin-customer-experience.png',
      '/images/company-admin/company-admin-personalization1.png',
    ],
  },
  {
    id: 'customization',
    IconComp: IconCustomization,
    iconBg: '#EEF2FF',
    accentColor: '#6366F1',
    sectionScreenshots: [
      '/images/company-admin/company-admin-personalization1.png',
      '/images/company-admin/company-admin-customer-experience.png',
      '/images/company-admin/company-admin-ideal-sales-flow.png',
      '/images/company-admin/company-admin-auto-followup.png',
    ],
  },
  {
    id: 'follow-up',
    IconComp: IconFollowUp,
    iconBg: '#ECFDF5',
    accentColor: '#10B981',
    sectionScreenshots: [
      '/images/salesperson/salesperson-whatsapp-followup.png',
      '/images/company-admin/company-admin-offline-followup.png',
      '/images/salesperson/salesperson-dashboard1.png',
    ],
  },
  {
    id: 'traffic-analytics',
    IconComp: IconTrafficAnalytics,
    iconBg: '#FEF2F2',
    accentColor: '#EF4444',
    sectionScreenshots: [
      '/images/manager/company-manager-traffic-analysis1.png',
      '/images/manager/company-manager-traffic-keywords.png',
      '/images/manager/company-manager-dashboard1.png',
    ],
  },
];

const copy = {
  en: {
    'meeting-minute': {
      title: 'Meeting Minute',
      shortDesc: 'AI-generated notes, summaries, and mind maps',
      sections: [
        { title: 'Smart Meeting Summaries', description: 'Generate notes after meetings and send via email. Get comprehensive summaries including Overview, What Went Well, Areas to Improve, Key Moments, Key Questions & Answers, Unanswered Questions, Recommendations, and Sentiment Analysis.' },
        { title: 'Visual Mind Maps', description: 'Transform meeting insights into visual mind maps covering Areas to Improve, What Went Well, Key Moments, and Question & Answer breakdowns.' },
      ],
    },
    'survey-form': {
      title: 'Survey Form',
      shortDesc: 'Create, manage, and analyze customer surveys',
      sections: [
        { title: 'Create & Manage Surveys', description: 'Create and manage active survey campaigns with ease. Launch new surveys in minutes, edit and manage questions anytime, export data, and view survey insights with an analytics dashboard.' },
        { title: 'Centralized Control', description: 'Manage all surveys in one place with a centralized dashboard. Download results and track response rates across your organization.' },
      ],
    },
    'ai-coaching': {
      title: 'AI Coaching',
      shortDesc: 'Data-driven, personalized sales coaching',
      sections: [
        { title: 'Personalized Skill Diagnosis', description: "Identify each rep's key improvement areas (e.g. closing techniques). Generate tailored coaching insights based on real conversations. Track performance with clear scoring and benchmarks." },
        { title: 'Conversation-Level Intelligence', description: 'Analyze every sales interaction automatically. Detect recurring issues (e.g. failure to drive next steps). Turn conversations into measurable performance metrics.' },
        { title: 'Top Performer Benchmarking', description: 'Compare behaviors against top-performing reps. Identify what great looks like in real scenarios. Scale winning habits across your team.' },
      ],
    },
    'training-needs': {
      title: 'Training Needs',
      shortDesc: 'Identify skill gaps and prioritize coaching',
      sections: [
        { title: 'AI-Driven Skill Gap Analysis', description: 'Identify skill gaps using AI insights. Prioritize coaching based on performance data. Deliver personalized training recommendations. Track improvement over time. Benchmark team and individual performance.' },
      ],
    },
    'audio-playback': {
      title: 'Audio Playback',
      shortDesc: 'Listen to and review recorded conversations',
      sections: [
        { title: 'Communication Logs', description: 'Listen to recorded conversations between salespeople and customers. Review key moments to evaluate sales performance. Identify strengths and areas for improvement from real interactions. Enable managers to conduct detailed call reviews and coaching.' },
        { title: 'Quality Assurance', description: 'Access recordings anytime for quality assurance and training purposes. Improve consistency by aligning conversations with ideal sales flow. View SQL Agent Log Details including Questions, Answers, SQL Attempts, and Executed SQL.' },
      ],
    },
    'location': {
      title: 'Location Tracking',
      shortDesc: 'Real-time GPS tracking for field teams',
      sections: [
        { title: 'Real-Time Team Monitoring', description: 'Monitor real-time locations of all sales team members. Gain visibility into field activity and customer engagement zones. Optimize territory coverage with data-driven insights. Improve team coordination and operational efficiency.' },
        { title: 'Manager-Level Access', description: 'Enhance accountability through transparent location monitoring. Access restricted to managers for better control and oversight.' },
      ],
    },
    'performance-scoring': {
      title: 'Performance Scoring',
      shortDesc: 'Measure, compare, and improve with structured scoring',
      sections: [
        { title: 'Team Performance Overview', description: 'See how your team performs at scale. Track key performance areas across all sales staff: Customer Engagement, Talk Time Balance, Objection Handling, Closing Effectiveness, and Product Knowledge. Identify team-wide strengths and gaps instantly.' },
        { title: 'Individual Performance Drilldown', description: 'Understand performance at an individual level: Overall Performance, Product Knowledge, Closing Rate, Customer Satisfaction, and Consistency. Get a clear picture of who needs support and where.' },
        { title: 'Smart Scoring System', description: "Score based on different skill sets and priorities. Adapt scoring models for different sales roles. Ensure fair and relevant evaluation across your team. Not all salespeople are the same — your scoring shouldn't be either." },
      ],
    },
    'customization': {
      title: 'Customization',
      shortDesc: 'Fully configurable to match your business',
      sections: [
        { title: 'Analysis Configuration', description: 'Choose insights to highlight. Detect specific customer questions. Track keywords that matter to your business.' },
        { title: 'KPI Scoring Configuration', description: 'Define your own scoring criteria. Assign weight to each KPI (total = 100%). Align evaluation with your business goals.' },
        { title: 'Ideal Sales Flow', description: 'Set your conversation stages. Define required steps. Ensure every interaction follows your standard.' },
        { title: 'Industry Terminology & Auto Follow-up', description: 'Add product names, define competitors, include internal or technical terms. Create WhatsApp follow-up messages, set when messages are triggered, and personalize communication at scale.' },
      ],
    },
    'follow-up': {
      title: 'Follow-up Automation',
      shortDesc: 'Turn conversations into immediate action',
      sections: [
        { title: 'One-Click WhatsApp Follow-up', description: 'Generate pre-filled messages based on conversation context. Tailored to customer intent (e.g. pricing, interest, objections). Review and send instantly via WhatsApp. No drafting. No delays. Just send.' },
        { title: 'Offline Follow-up', description: 'Company admin can monitor all offline follow-up messages sent by the company team, including salespeople and other admins.' },
        { title: 'Email Follow-up', description: 'Turn conversations into actionable emails. Send the right message to the right person. Eliminate manual follow-up work. Each participant gets a relevant response, from quotation to payment to nurturing.' },
      ],
    },
    'traffic-analytics': {
      title: 'Traffic Analytics',
      shortDesc: 'Real-time view of performance and trends',
      sections: [
        { title: 'Conversation Overview', description: "Filter and analyze conversations by customer intention, success rate, and KPI score. Instantly identify what's working — and what's not." },
        { title: 'Volume & Trends', description: 'Monitor total conversations over time. Identify peak periods and activity patterns. Understand team workload and engagement levels.' },
        { title: 'Top Performers & Keywords', description: 'Highlight high-performing staff or interactions. Identify winning behaviors and replicate what works. Break down conversations into key themes: Products, Competitors, Financial discussions, and Urgency signals.' },
      ],
    },
  },
  zh: {
    'meeting-minute': {
      title: '会议纪要',
      shortDesc: 'AI 自动生成会议记录、摘要与思维导图',
      sections: [
        { title: '智能会议摘要', description: '会后自动生成会议记录并通过邮件发送。获取完整摘要,包括概览、做得好的地方、待改进点、关键时刻、重点问答、未解问题、优化建议以及情感分析。' },
        { title: '可视化思维导图', description: '将会议洞察转化为可视化思维导图,涵盖待改进点、做得好的地方、关键时刻以及问答拆解。' },
      ],
    },
    'survey-form': {
      title: '问卷调查',
      shortDesc: '轻松创建、管理并分析客户问卷',
      sections: [
        { title: '创建与管理问卷', description: '轻松创建并管理进行中的问卷活动。数分钟内发布新问卷,随时编辑题目,导出数据,并通过分析看板查看问卷洞察。' },
        { title: '集中管控', description: '通过集中式看板在同一处管理所有问卷。下载结果,跨组织追踪回复率。' },
      ],
    },
    'ai-coaching': {
      title: 'AI 辅导',
      shortDesc: '数据驱动的个性化销售辅导',
      sections: [
        { title: '个性化能力诊断', description: '精准定位每位销售人员的重点提升方向(如成交技巧)。基于真实对话生成定制化辅导建议。以清晰的评分和基准追踪绩效表现。' },
        { title: '对话级智能洞察', description: '自动分析每一次销售互动。识别反复出现的问题(如未能推进下一步)。将对话转化为可量化的绩效指标。' },
        { title: '对标优秀销售', description: '将日常行为与团队顶尖销售进行对比。在真实场景中看清「卓越」长什么样。将制胜习惯规模化推广至整个团队。' },
      ],
    },
    'training-needs': {
      title: '培训需求',
      shortDesc: '识别能力短板,优先安排辅导',
      sections: [
        { title: 'AI 驱动的能力差距分析', description: '借助 AI 洞察识别能力短板。基于绩效数据确定辅导优先级。提供个性化培训建议,持续追踪改进进度,并对团队与个人表现进行基准对比。' },
      ],
    },
    'audio-playback': {
      title: '音频回放',
      shortDesc: '聆听并复盘已录制的对话',
      sections: [
        { title: '沟通记录', description: '聆听销售人员与客户之间的录音对话。复盘关键时刻,评估销售表现。从真实互动中发现优势与改进点,帮助管理者进行深度复盘与辅导。' },
        { title: '质量保证', description: '随时访问录音,用于质量审核与培训。通过对齐理想销售流程提升一致性。查看 SQL Agent 日志详情,包括问题、答案、SQL 尝试及已执行的 SQL。' },
      ],
    },
    'location': {
      title: '定位追踪',
      shortDesc: '为外勤团队提供实时 GPS 追踪',
      sections: [
        { title: '实时团队监控', description: '实时掌握全体销售团队成员的位置。洞察外勤活动与客户互动热区。以数据驱动优化区域覆盖。提升团队协同与运营效率。' },
        { title: '管理者专属权限', description: '通过透明的位置监控增强问责机制。访问权限仅对管理者开放,以实现更好的管控与监督。' },
      ],
    },
    'performance-scoring': {
      title: '绩效评分',
      shortDesc: '以结构化评分体系衡量、对比并持续提升',
      sections: [
        { title: '团队绩效总览', description: '以规模化视角掌握团队表现。追踪全体销售人员的关键绩效维度:客户互动、发言时长平衡、异议处理、成交效率与产品知识。一眼识别团队级优势与短板。' },
        { title: '个人绩效深度洞察', description: '从个人维度看清表现:整体绩效、产品知识、成交率、客户满意度与稳定性。清晰了解谁需要支持以及在哪些方面需要支持。' },
        { title: '智能评分系统', description: '根据不同技能组合与侧重点进行评分。针对不同销售角色调整评分模型。确保团队内部评估公平且相关。销售人员各有不同 —— 评分方式也不应千篇一律。' },
      ],
    },
    'customization': {
      title: '深度定制',
      shortDesc: '完全可配置,贴合您的业务',
      sections: [
        { title: '分析配置', description: '自选需要重点呈现的洞察。识别特定的客户提问。追踪对您业务至关重要的关键词。' },
        { title: 'KPI 评分配置', description: '自定义评分标准。为每项 KPI 分配权重(总和为 100%)。让评估与您的业务目标保持一致。' },
        { title: '理想销售流程', description: '设定对话阶段,定义必做步骤,确保每一次互动都符合您的标准。' },
        { title: '行业术语与自动跟进', description: '添加产品名称、设定竞品、纳入内部或技术术语。创建 WhatsApp 跟进消息,设定触发时机,实现规模化的个性化沟通。' },
      ],
    },
    'follow-up': {
      title: '自动跟进',
      shortDesc: '将对话即时转化为行动',
      sections: [
        { title: '一键 WhatsApp 跟进', description: '基于对话内容生成预填消息。根据客户意向定制(如价格、兴趣或异议)。审阅后通过 WhatsApp 即时发送。无需起草,无需等待,直接发送。' },
        { title: '线下跟进', description: '公司管理员可监控团队成员(包括销售人员及其他管理员)发送的所有线下跟进消息。' },
        { title: '邮件跟进', description: '将对话转化为可执行的邮件。将合适的信息发送给合适的人。免除人工跟进的繁琐工作。每位参与者都能收到相应的跟进,从报价、付款到长期维护皆可覆盖。' },
      ],
    },
    'traffic-analytics': {
      title: '流量分析',
      shortDesc: '实时掌握绩效表现与趋势变化',
      sections: [
        { title: '对话总览', description: '按客户意向、成功率与 KPI 分数筛选并分析对话。即刻看清什么有效、什么无效。' },
        { title: '数量与趋势', description: '追踪不同时间段的对话总量。识别高峰时段与活动规律。洞察团队工作负荷与参与程度。' },
        { title: '顶尖表现者与关键词', description: '突出高绩效成员与优质互动。识别制胜行为并复制可行做法。将对话按关键主题拆解:产品、竞品、财务讨论与紧迫信号。' },
      ],
    },
  },
};

const buildFeatures = (lang) => {
  const dict = copy[lang] || copy.en;
  return featureBase.map((f) => {
    const c = dict[f.id];
    return {
      id: f.id,
      icon: <f.IconComp />,
      iconBg: f.iconBg,
      accentColor: f.accentColor,
      title: c.title,
      shortDesc: c.shortDesc,
      sections: c.sections.map((s, i) => ({
        title: s.title,
        description: s.description,
        screenshot: f.sectionScreenshots[i],
      })),
    };
  });
};

export const getProductFeatures = (lang) => buildFeatures(lang === 'zh' ? 'zh' : 'en');
